module.exports = __webpack_public_path__ + "static/media/icons_Bilan G‚riatrie.faf548ea.svg";